import React, { useContext, useState, useEffect } from "react";
import { Formik } from "formik";
import { signin } from "../../api/api-auth.js";
import { StateContext } from "../../contexts/StateContext";
import {
  Image,
  Row,
  Col,
  Container,
  ButtonGroup,
  Button,
  Form,
  InputGroup,
  Stack,
} from "react-bootstrap";
import * as Yup from "yup";
import { CustomField } from "./CustomField.js";

const schema = Yup.object().shape({
  username: Yup.string()
    .min(3, "Username is to short")
    .required("This field is required"),
  password: Yup.string()
    .min(6, "Password is to short")
    .required("This field is required"),
});

const Login = ({ setShowLoginModal, setRegister }) => {
  const { user, setUser } = useContext(StateContext);
  const [apiError, setApiError] = useState("");

  const onSubmitHandler = async (e, values) => {
    e.preventDefault();
    try {
      const response = await signin(values);
      if (response?.user) {
        setUser(response.user);
        setApiError("");
        setShowLoginModal(false);
      } else if (response?.error) {
        setApiError(
          response?.error?.response?.data.error || response.error.message
        );
        console.log(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="right-pane">
      <Formik
        initialValues={{
          username: "",
          password: "",
        }}
        validationSchema={schema}
      >
        {({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            <CustomField label="Username" name="username" />
            <CustomField label="Password" name="password" type="password" />
            <button
              disabled={!(isValid && dirty) || isSubmitting}
              onClick={(e) => {
                onSubmitHandler(e, values);
              }}
            >
              SIGN IN
            </button>
            <div className="error-message">{apiError}</div>
          </Form>
        )}
      </Formik>
      <div>
        No account? &nbsp;
        <span
          className="text-primary"
          onClick={() => {
            setRegister(true);
          }}
        >
          Sign up!
        </span>
      </div>
    </div>
  );
};

export default Login;
